const BOT_RE = /bot|crawler|spider|slurp|googlebot|bingbot|yandex|baiduspider|duckduckbot|applebot|facebookexternalhit|linkedinbot|twitterbot|whatsapp|telegrambot|prerender|rendertron|headless|lighthouse|pagespeed|gptbot|claudebot|anthropic|perplexitybot|amazonbot|ccbot|bytespider/i;

export const isBot = () => {
  try {
    return Boolean(navigator.webdriver) || BOT_RE.test(navigator.userAgent || "");
  } catch {
    return false;
  }
};
